import moment from "moment";
import * as momentTz from "moment-timezone";
moment.tz.setDefault("UTC");

export default moment;
